import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 9 14.95",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 14.95\" id=\"arrow-right\"><title>arrow-right</title><path d=\"M.45,14.5a1.51,1.51,0,0,0,2.15,0h0l6-6a1.52,1.52,0,0,0,0-2.15h0L2.59.44A1.52,1.52,0,1,0,.45,2.59L5.33,7.47.45,12.35a1.52,1.52,0,0,0,0,2.15h0\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol